import {
	Speedometer,
	EmojiNormal,
	TimerStart,
	Timer,
	Mobile,
	GlobalEdit,
	CalendarCircle,
	UserTag,
	Cards
} from 'iconsax-react';

import TickIcon from 'assets/icons/tick.svg';

import classes from './ContentBenefits.module.scss';

const ContentBenefits = ({ contentType = 'course', title }) => {
	return (
		<div className={`${classes['content-benefits-wrapper']} d-flex flex-column gap-3`}>
			<h3>Benefits of this {contentType === 'course' ? 'Course' : 'Job Qualification'}</h3>
			<p>Get valuable resources, and ISO backed certification through our assessment of your knowledge and access global jobs only for Pharmuni alumni.</p>
			<ul>
				<li>
					<TickIcon /> Downloadable Resources
				</li>
				<li>
					<TickIcon /> Fast-Tracked Qualification
				</li>
				<li>
					<TickIcon /> Exclusive Assessment Quiz
				</li>
				<li>
					<TickIcon /> Skill Tree Levelup
				</li>
				<li>
					<TickIcon /> Customer Support
				</li>
				<li>
					<TickIcon /> Sharable &  Downloadable Certification
				</li>				
			</ul>
		</div>
	);
};

export default ContentBenefits;
